<div class="divPrincipal" fxLayout="column" fxLayoutAlign="start stretch">

    <div class="courses" fxLayout="row" fxLayoutAlign="center">
        <div class="cursoCard" fxFlex="50" fxFlex.gt-xs="50" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">
            <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center" style="padding-bottom: 15px;">
                    <div class="category" fxFlex>
                        {{'SHEDULE.TITLE1' | translate}}
                    </div>
                </div>
                <!--------- PICK DATE ------->
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4" style="padding-top: 10px;">
                    <mat-label>{{'SHEDULE.FECHA' | translate}}</mat-label>
                    <input matInput required disabled value="{{ labelDate }}">
                    <mat-icon matSuffix class="secondary-text">calendar_today</mat-icon>
                </mat-form-field>
                <!------- boton  --------->
                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button color="accent" (click)="addDate(1)" [disabled]="remaindStatus">{{'SHEDULE.EDITAR' | translate}}</button>
                </div>
            </div>
        </div>
        <!-- Recordatorios-->
        <div class="cursoCard" fxFlex="50" fxFlex.gt-xs="50" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">
            <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
                <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center" style="padding-bottom: 15px;">
                    <div class="category" fxFlex>
                        {{'SHEDULE.TITLE2' | translate}}
                    </div>
                </div>
                <!--------- PICK DATE ------->
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4" style="padding-top: 10px;">
                    <mat-label>{{'SHEDULE.FECHA' | translate}}</mat-label>
                    <input matInput required disabled value="{{ labelDate2 }}">
                    <mat-icon matSuffix class="secondary-text">calendar_today</mat-icon>
                </mat-form-field>
                <!------- boton  --------->
                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button color="accent" (click)="saverecordatorio()" [disabled]="bloquearRecordatorios">{{'SHEDULE.EDITAR' | translate}}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="courses" fxLayout="row" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
        <div class="example-button-row" fxLayoutAlign="center" style="padding-bottom: 10px;">
            <button *ngIf="!pasoCompleto && flagbutton" mat-raised-button color="primary" (click)="velidateBanderas();" [disabled]="pilotSurvey">{{'SHEDULE.BTNSURVEY' | translate}}</button>
        </div>
    </div>

    <div class="courses mb-20" fxLayout="row" fxLayoutAlign="center stretch" [@animateStagger]="{value:'50'}">
        <mat-expansion-panel fxFlex="50" [expanded]="true" *ngIf="expPanel">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{'SHEDULE.ENCUESTA' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    ...
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="example-button-row" fxLayout="column" fxLayoutAlign="start stretch" style="padding-bottom: 10px;">
                <div *ngIf="flagEncuesta == 1">
                    <code style="center">{{'SHEDULE.ENCUESTA' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="encuestaOk">
                    {{'SHEDULE.SUCCESS_ENCUESTA' | translate}}
                </div>
            </div>
            <!--CREACIÓN DE MÁS DE 50-->
            <div class="example-button-row" fxLayout="column" fxLayoutAlign="start stretch" style="padding-bottom:10px;">
                <div *ngIf="flagEncuestaMas50 == 1">
                    <code style="center">{{'SHEDULE.MAS50' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="mas50Ok">
                    {{'SHEDULE.SUCCESS_MAS50' | translate}}
                </div>
            </div>
            <!--FIN DE MAS DE 50-->

            <!--CREACIÓN DE MENOS DE 50-->
            <div class="example-button-row" fxLayout="column" fxLayoutAlign="start stretch" style="padding-bottom:10px;">
                <div *ngIf="flagEncuestaMenos50 == 1">
                    <code style="center">{{'SHEDULE.MENOS' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="menos50Ok">
                    {{'SHEDULE.SUCCESS_MENOS' | translate}}
                </div>
            </div>
            <!--FIN DE MENOS DE 50-->

            <!--CREACIÓN DE USUARIOS-->
            <div class="example-button-row" fxLayout="column" fxLayoutAlign="start stretch" style="padding-bottom:10px;">
                <div *ngIf="flagUsers == 1">
                    <code style="center">{{'SHEDULE.USERS' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="usuariosOk">
                    {{'SHEDULE.SUCCESS_USUARIOS' | translate}}
                </div>
            </div>
            <!--FIN DE USUARIOS-->

        </mat-expansion-panel>
    </div>

    <div class="courses mb-40" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
        <ng-container>
            <div>
                <mat-icon aria-hidden="false" class="mr-20" matTooltip="" style="display:none">menu</mat-icon>
                <mat-expansion-panel class="mb-20">
                    <mat-expansion-panel-header class="accent-100">
                        <mat-panel-title>
                            {{'SHEDULE.RECORDATORIOS' | translate}}
                        </mat-panel-title>
                        <mat-panel-description>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <!--------- PICK DATE ------->
                    <mat-list *ngIf=" statusTipo">
                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER1' | translate}} {{arrayRemainders[0].fechaRecordatorio |date:"fullDate":'':idiomaActual}}</p>
                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER6' | translate}} {{arrayRemainders[5].fechaRecordatorio |date:"fullDate":'':idiomaActual}}</p>
                        </mat-list-item>

                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER2' | translate}} {{arrayRemainders[1].fechaRecordatorio |date:"fullDate":'':idiomaActual}}</p>

                        </mat-list-item>

                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER7' | translate}} {{arrayRemainders[6].fechaRecordatorio |date:"fullDate":'':idiomaActual}}</p>

                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER3' | translate}} {{arrayRemainders[2].fechaRecordatorio |date:"fullDate":'':idiomaActual}}</p>
                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER4' | translate}} {{arrayRemainders[3].fechaRecordatorio |date:"fullDate":'':idiomaActual}} </p>

                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER5' | translate}} {{arrayRemainders[4].fechaRecordatorio |date:"fullDate":'':idiomaActual}}</p>
                        </mat-list-item>

                        <mat-divider></mat-divider>
                    </mat-list>
                    <mat-list *ngIf="statusTipo2">
                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER3' | translate}} {{arrayRemainders[0].fechaRecordatorio |date:"fullDate":'':idiomaActual}}</p>
                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER4' | translate}} {{arrayRemainders[1].fechaRecordatorio |date:"fullDate":'':idiomaActual}} </p>

                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon mat-list-icon>calendar_today</mat-icon>
                            <p>{{'SHEDULE.REMAINDER.REMAINDER5' | translate}} {{arrayRemainders[2].fechaRecordatorio |date:"fullDate":'':idiomaActual}}</p>
                        </mat-list-item>

                        <mat-divider></mat-divider>
                    </mat-list>
                    <ng-container *ngIf="statusTipo || statusTipo2">
                        <mat-list *ngFor="let pos of arrayRemaindersExt; let k = index">
                            <mat-list-item>
                                <mat-icon mat-list-icon>calendar_today</mat-icon>
                                <p>{{'SHEDULE.REMAINDER.REMAINDER51' | translate}} {{k+1}}: {{pos.fechaRecordatorio |date:"fullDate":'':idiomaActual}}</p>
                            </mat-list-item>

                        </mat-list>

                    </ng-container>


                    <!------- boton  --------->
                </mat-expansion-panel>
            </div>
        </ng-container>




    </div>

    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
        <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'SHEDULE.COMPLETAR_PASO' | translate}}" matTooltipPosition="left" class="undone mr-20" (click)="completarPaso()">
      <mat-icon>done</mat-icon>
    </button>
        <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'SHEDULE.PASO_COMPLETADO' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>
    </div>

</div>
